/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { Fragment, useState, useRef, useEffect } from 'react';
import customStyles from "../../../../../../assets/styles/customStyles";
import { Row, Col, Input } from "antd";
import { NavLink } from "react-router-dom";
import clsx from 'clsx';
import { getRequest } from '../../../../../../helpers/axiosClient';
import { VirtualKeyboard } from './VirtualKeyboard';
import { useEventListener } from "../../../../../../helpers/useEventListener";
import ClearIcon from "../../../../../../assets/images/icon_actions/Clear Icon.svg";


export const KeyBoardView = (props) => {
    const { handleGridClick, activeInputs, handleActiveInputs, visible } = props;
    const [keyBoardForm, setKeyBoradForm] = useState({});
    const [product, setProduct] = useState({});
    const [error, setError] = useState({});
    const classes = customStyles();
    const codeRef = useRef('');
    const quantityRef = useRef('');
    const keyboardRef = useRef('');

    const changeHandler = (e) => {
        setKeyBoradForm({
            ...keyBoardForm,
            [e.target.name]: e.target.value
        })
    }

    const onEnterPressed = (e) => {
        e.preventDefault();
        if (e.target.name === 'code') {
            if (e.target.value !== '') {
                try {
                    let filter = { where: { ["and"]: [{ status: 'ACTIVE' }, { code: e.target.value }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] } };
                    let response = getRequest(`${process.env.REACT_APP_API_URL}/client-products?filter=${encodeURIComponent(JSON.stringify(filter))}`);
                    response.then(payload => {
                        // Handle the fetched data here
                        let data = payload.data;
                        if (data && data?.length) {
                            setProduct(data[0]);
                            setError({
                                [e.target.name]: ''
                            });
                            quantityRef.current.focus();
                        }
                    }).catch(error => {
                        // Handle any errors
                    })
                } catch (error) {

                }
            } else {
                setError({
                    [e.target.name]: 'Please fill code value before press enter'
                });
            }
        } else if (e.target.name === 'quantity') {
            if (e.target.value !== '') {
                handleActiveInputs('');
                handleGridClick(product, e.target.value);
                setKeyBoradForm({});
                setProduct('');
                setError({
                    [e.target.name]: ''
                });
                codeRef.current.focus();
            } else {
                setError({
                    [e.target.name]: 'Please fill qunatity value before press enter'
                });
            }
        }
    }

    const onKeyPress = (key) => {
        setKeyBoradForm({
            ...keyBoardForm,
            [activeInputs]: keyBoardForm[activeInputs] ? keyBoardForm[activeInputs] += key : key
        });
    }

    const onKeyEnter = () => {
        const event = new KeyboardEvent('keydown', {
            key: 'Enter',
            bubbles: true,
        });
        if (activeInputs === 'code' && codeRef.current) {
            codeRef.current.input.dispatchEvent(event);
        } else if (activeInputs === 'quantity' && quantityRef.current) {
            quantityRef.current.input.dispatchEvent(event);
        } else {
            codeRef.current.focus();
        }
    }

    const handleKeyDown = (e) => {
        if (!visible && e.keyCode === 13) {
            if (codeRef.current)
                codeRef.current.focus();
        }
    };

    useEventListener("keydown", handleKeyDown);

    useEffect(() => {
        if (codeRef?.current)
            codeRef.current.focus();
    }, []);

    const handleClearProductCode = () => {
        setKeyBoradForm({});
        setProduct({});
    }

    return (
        <Fragment>
            <Row className={clsx(classes.keyboard)}>
                <Col span={24}>
                    <div className={clsx(classes.keyboardbox)}>
                        <Row>
                            <Col span={12}>
                                <div className={clsx(classes.keyboardboxlabel)}>Product Code</div>
                                <Input
                                    value={keyBoardForm?.code || ''}
                                    name={'code'}
                                    ref={codeRef}
                                    id={'codeId'}
                                    className={clsx(classes.inputField)}
                                    onPressEnter={(e) => onEnterPressed(e)}
                                    onChange={(e) => changeHandler(e)}
                                    autoComplete="off"
                                    onFocus={(e) => handleActiveInputs(e.target.name)}
                                    status={error?.code ? 'error' : ''}
                                    suffix={
                                        <>
                                            {
                                                keyBoardForm?.code && <NavLink to="#" onClick={() => handleClearProductCode()} className={classes.searchClear}>
                                                    <img className={classes.searchClearImg} src={ClearIcon} alt={'alear'} />
                                                </NavLink>
                                            }
                                        </>
                                    }
                                />
                            </Col>
                            <Col span={12}>
                                <div className={clsx(classes.keyboardboxlabel)}>Quantity</div>
                                <Input
                                    value={keyBoardForm?.quantity || ''}
                                    name={'quantity'}
                                    ref={quantityRef}
                                    className={clsx(classes.inputField)}
                                    onPressEnter={(e) => onEnterPressed(e)}
                                    onChange={(e) => changeHandler(e)}
                                    autoComplete="off"
                                    onFocus={(e) => handleActiveInputs(e.target.name)}
                                    status={error?.quantity ? 'error' : ''}
                                    suffix={
                                        <>
                                            {
                                                keyBoardForm?.quantity && <NavLink to="#" onClick={() => setKeyBoradForm({
                                                    ...keyBoardForm,
                                                    "quantity": ''
                                                })} className={classes.searchClear}>
                                                    <img className={classes.searchClearImg} src={ClearIcon} alt={'alear'} />
                                                </NavLink>
                                            }
                                        </>
                                    }
                                    disabled={product?.productName ? false : true}
                                />
                            </Col>
                            {
                                product?.productName ? <Col span={24}>
                                    <div className={clsx(classes.keyboardboxlabel)}>Product</div>
                                    <div className={clsx(classes.keyboardboxprod)}>{product?.productName || 'test'}</div>
                                </Col> : <Col span={24}>
                                    <div className={clsx(classes.keyboardboxlabel)}>Enter Product Code to Display the Name</div>
                                    <div className={clsx(classes.keyboardboxprod)} style={{ opacity: 0 }}>{product?.productName || 'test'}</div>
                                </Col>
                            }
                        </Row>
                    </div>
                </Col>
                <Col span={24}>
                    <VirtualKeyboard ref={keyboardRef} {...props} onKeyPress={(k) => onKeyPress(k)} onKeyEnter={(k) => onKeyEnter(k)} />
                </Col>
            </Row>
        </Fragment>
    )
}